module.exports = __webpack_public_path__ + "static/media/linda_vollmer_teaching.82f41d12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/linda_vollmer_teaching.jpg
// module id = 600
// module chunks = 0